import { useUserStore } from "../../store/userStore";

export function getCanUseSG(): boolean {
  return useUserStore.getState().user?.canUseSG === true;
}

export function assertCanUseSG(): void {
  if (!getCanUseSG()) {
    throw new Error("No tienes permisos para administrar el módulo SG.");
  }
}
